import { render, staticRenderFns } from "./productos.vue?vue&type=template&id=5275e5e2&scoped=true&"
import script from "./productos.vue?vue&type=script&lang=js&"
export * from "./productos.vue?vue&type=script&lang=js&"
import style0 from "./productos.vue?vue&type=style&index=0&id=5275e5e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5275e5e2",
  null
  
)

export default component.exports